<template>
	<div class="icon-input-search">
		<svg
			width="15.426758"
			height="15.426758"
			viewBox="0 0 15.4268 15.4268"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs />
			<path
				id="path"
				d="M1.12 7.31C1.12 6.49 1.28 5.7 1.59 4.94C1.9 4.18 2.35 3.51 2.93 2.93C3.51 2.35 4.18 1.9 4.94 1.59C5.7 1.28 6.49 1.12 7.31 1.12C8.13 1.12 8.92 1.28 9.68 1.59C10.43 1.9 11.1 2.35 11.68 2.93C12.26 3.51 12.71 4.18 13.02 4.94C13.34 5.7 13.5 6.49 13.5 7.31C13.5 8.13 13.34 8.92 13.02 9.68C12.71 10.43 12.26 11.1 11.68 11.68C11.1 12.26 10.43 12.71 9.68 13.02C8.92 13.34 8.13 13.5 7.31 13.5C6.49 13.5 5.7 13.34 4.94 13.02C4.18 12.71 3.51 12.26 2.93 11.68C2.35 11.1 1.9 10.43 1.59 9.68C1.28 8.92 1.12 8.13 1.12 7.31ZM7.31 0C3.27 0 0 3.27 0 7.31C0 11.35 3.27 14.62 7.31 14.62C9.11 14.62 10.7 14.04 12.07 12.86L14.41 15.21C14.67 15.49 14.94 15.49 15.22 15.22C15.49 14.94 15.49 14.67 15.21 14.41L12.86 12.07C14.04 10.7 14.62 9.11 14.62 7.31C14.62 3.27 11.35 0 7.31 0Z"
				fill="#77797C"
				fill-opacity="1.000000"
				fill-rule="evenodd"
			/>
		</svg>
	</div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";

export default class IconInputSearch extends Vue {}
</script>

<style scoped lang="scss">
.icon-input-search {
	display: flex;
}
</style>
